import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { TrendingUp, AlertTriangle, Activity, Zap } from 'lucide-react';

export function OpsPage() {
  return (
    <div className="p-6 lg:p-8">
      <header className="mb-6">
        <h1 className="text-2xl font-semibold tracking-tight">运营中心</h1>
        <p className="mt-1 text-sm text-neutral-600">
          多平台数据 · AI 洞察卡片 · 一键回传工单
        </p>
      </header>

      <section className="mb-6 grid grid-cols-2 gap-4 md:grid-cols-4">
        {[
          { label: '今日完播率', value: '64.2%', diff: '+3.1pp', kind: 'success' as const },
          { label: '24h 互动', value: '12.3w', diff: '+18%', kind: 'success' as const },
          { label: '风险工单', value: '2', diff: '红 1', kind: 'danger' as const },
          { label: '投流 ROI', value: '1.84', diff: '-0.06', kind: 'warning' as const },
        ].map((k) => (
          <Card key={k.label}>
            <CardContent className="space-y-1 py-4">
              <div className="text-xs text-outline">{k.label}</div>
              <div className="text-2xl font-semibold tracking-tight">{k.value}</div>
              <Badge variant={k.kind}>{k.diff}</Badge>
            </CardContent>
          </Card>
        ))}
      </section>

      <section className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Activity className="h-4 w-4 text-info" /> 留存热力图(EP1-12)
            </CardTitle>
            <CardDescription>横轴=集数,纵轴=分钟,色深=用户留存率</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-12 gap-0.5">
              {Array.from({ length: 12 * 8 }).map((_, i) => {
                const v = ((i * 13) % 100) / 100;
                return (
                  <div
                    key={i}
                    className="aspect-square rounded-sm"
                    style={{ background: `rgba(0,97,164,${v.toFixed(2)})` }}
                  />
                );
              })}
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Zap className="h-4 w-4 text-warning" /> AI 洞察卡片
            </CardTitle>
            <CardDescription>大爆 / 断崖双轨预警</CardDescription>
          </CardHeader>
          <CardContent className="space-y-3">
            <InsightItem
              kind="spike"
              title="EP07 数据大爆 ↑ 218%"
              detail="14s 处「打耳光」镜头被截图传播,建议立刻加码投流并复用切片"
            />
            <InsightItem
              kind="cliff"
              title="EP08 完播断崖 -32pp"
              detail="第 45-90s 「剧情平原」,建议插入小反转(工单已生成)"
            />
          </CardContent>
        </Card>
      </section>
    </div>
  );
}

function InsightItem({
  kind,
  title,
  detail,
}: {
  kind: 'spike' | 'cliff';
  title: string;
  detail: string;
}) {
  const Icon = kind === 'spike' ? TrendingUp : AlertTriangle;
  const tone = kind === 'spike' ? 'success' : 'danger';
  return (
    <div className="rounded-lg border border-outline-variant/20 p-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 text-sm font-medium">
          <Icon
            className={`h-4 w-4 ${kind === 'spike' ? 'text-success' : 'text-danger'}`}
          />
          {title}
        </div>
        <Badge variant={tone}>一键回传</Badge>
      </div>
      <p className="mt-1 text-xs text-neutral-600">{detail}</p>
    </div>
  );
}
